import { Box, Divider } from '@material-ui/core';
import { useEffect } from 'react';
import { Comparison, Project } from '../../../redux';
import { Body1, Header4 } from '../../atoms';
import { DialogWindow } from '../dialog-window/dialog-window.component';
import { SmallMapCard } from '../small-map-card/small-map-card.component';

import './selector-overview-popup.styles.scss';

export interface ISelectorOverviewPopupProps {
	title: string;
	subtitle?: string;
	open: boolean;
	selectedProjects: Project[];
	selectedComparisons?: Comparison[];
	onClose: () => void;
	fetchBosatlas: () => void;
}

export function SelectorOverviewPopup(props: ISelectorOverviewPopupProps) {
	const {
		title,
		subtitle,
		open,
		selectedProjects,
		selectedComparisons,
		onClose,
		fetchBosatlas
	} = props;

	useEffect(() => {
		return () => {
			fetchBosatlas();
		};
	}, []);

	function showProjectDivider(index: number): boolean {
		if (index < selectedProjects.length - 1) return true;
		if (selectedComparisons)
			return (
				selectedComparisons.length > 0 && selectedProjects.length > 0
			);
		return false;
	}

	return (
		<DialogWindow
			open={open}
			onClose={onClose}
			className="selector-overview-popup"
		>
			<Header4 className="selector-overview-title">{title}</Header4>
			{subtitle && (
				<Body1 className="selector-overview-subtitle">{subtitle}</Body1>
			)}
			{selectedProjects.map((project: Project, index: number) => (
				<Box key={index}>
					<SmallMapCard
						className="selected-project"
						thumbnailSrc={project.thumbnailUrl}
						title={project.title}
					/>
					{showProjectDivider(index) && <Divider />}
				</Box>
			))}
			{selectedComparisons &&
				selectedComparisons.map(
					(comparison: Comparison, index: number) => (
						<Box key={index}>
							<SmallMapCard
								className="selected-project"
								comparison={comparison}
							/>
							{index < selectedComparisons.length - 1 && (
								<Divider />
							)}
						</Box>
					)
				)}
		</DialogWindow>
	);
}
